import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/* eslint-disable react/display-name */
import React from 'react';
import { compose, branch, setDisplayName } from 'recompose';
import _ from 'lodash';
var isArray = _Array$isArray;

var serialize = function serialize(fn) {
  return fn.name + fn.displayName + fn.toString();
};

var serializeDeferred = function serializeDeferred(__deferred) {
  return _reduceInstanceProperty(__deferred).call(__deferred, function (acc, fn) {
    var _context;

    return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(acc), [serialize(fn)]);
  }, '');
};

var cacheKeyGen = function cacheKeyGen(Component, __deferred) {
  return serialize(Component) + serializeDeferred(__deferred);
};

var deferredComponent = _.memoize(function (Component, __deferred) {
  return compose.apply(void 0, _toConsumableArray(__deferred))(Component);
}, cacheKeyGen);

var withDeferredBehaviour = compose(setDisplayName('behaviour(Deferred)'), function (Component) {
  return function (_ref) {
    var __deferred = _ref.__deferred,
        props = _objectWithoutProperties(_ref, ["__deferred"]);

    var ComponentWithDeferredBehaviour = deferredComponent(Component, __deferred);
    return React.createElement(ComponentWithDeferredBehaviour, props);
  };
});
export var defer = function defer(hoc) {
  return function (Component) {
    return function (_ref2) {
      var _context2;

      var _ref2$__deferred = _ref2.__deferred,
          __deferred = _ref2$__deferred === void 0 ? [] : _ref2$__deferred,
          props = _objectWithoutProperties(_ref2, ["__deferred"]);

      return React.createElement(Component, _extends({}, props, {
        __deferred: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(__deferred), [hoc])
      }));
    };
  };
};
export default compose(branch(function (_ref3) {
  var __deferred = _ref3.__deferred;
  return isArray(__deferred) && __deferred.length;
}, withDeferredBehaviour));